// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"5e0910a7","717":"53b4f407","893":"0feabcbe"}[chunkId] + ".chunk.css";
};